const url = "https://vtz.quizzzmaster.com/tnzapi";
//const url = "/tnzapi";
//const url = "http://localhost:1010/quizMasterApis";
export default url;


